import Visita from "../";

const routes = [
    { name: "VisitaList", path: "/paziente/eventi/visite/", component: Visita.VisiteList, meta: { title: "patient.menu.lblVisit" } },
    { name: "VisitaView", path: "/paziente/eventi/visita/view/:id", component: Visita.VisitaView, meta: { title: "patient.menu.lblVisit" } },
    { name: "VisitaEdit", path: "/paziente/eventi/visita/edit/:id", component: Visita.VisitaEdit, meta: { title: "patient.menu.lblVisit" } },
];
export default routes;
